import CdHeader from "./header.vue";

// CdButton.install = function (Vue) {
//     Vue.component(CdButton.name, CdButton)
// }

export default CdHeader;
